import React, { Component } from 'react';
import convert from 'convert-units';
import DatePicker from "react-datepicker";
import Loadable from '../../ui/loading/Loadable.js';
import ShowIff from '../../ui/ShowIff.js';

import "react-datepicker/dist/react-datepicker.css";
import api from '../../../api/index.js';

class AddRowForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			text: '',
			units: false,
			startDate: new Date(),
			startDatePreset: 'today'
		};
		
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onRowsAdded = this.onRowsAdded.bind(this);
	}
	
	onChange(e) {
		this.setState({[e.target.name]: e.target.value});
	}
	
	onDatePresetChange = (e) => {
		let date = this.state.startDate;
		switch(e.target.value) {
			case 'today':
				date = new Date();
				break;
			case 'field':
				date = new Date(this.props.field.StartDate);
				break;
			default:
				// Do nothing
		}
		console.log("Setting dates", date, e.target.value);
		this.setState({
			startDate: date,
			startDatePreset: e.target.value
		});
	}
	
	onStartDateChange = (date) => {
		this.setState({
			startDate: date
		});
	}
	
	async refresh() {
		this.setState({units: await api.settings.get('display_units')});
	}
	
	componentDidMount() {
		this.refresh();
		// Get the thing from the api
	}
	
	async onSubmit(e) {
		e.preventDefault();
		try {
			const rows = this.parse(this.state.text);
			let r = await api.post('farms/' + this.props.FarmID + '/fields/' + this.props.FieldID + '/rows', {rowdata: JSON.stringify(rows), StartDate: this.state.startDate.toISOString()});
			api.success('Rows added', r);
			if (this.props.onAdded)
				this.props.onAdded(r);
		} catch(e) {
			api.handleExceptions(e);
		}
	}
	
	
	parse(text) {
		text = text.trim();
		if (text.length === 0)
			throw new Error("Please supply some row data.");
		const lines = text.split("\n");
		let rows = [];
		for(let i=0; i < lines.length; i++) {
			const chunks = lines[i].trim().split(':');
			if (chunks.length !== 2) {
				throw new Error("Expected two chunks, but received " + chunks.length + " on line " + (i+1));
			}
			const rowchunks = chunks[0].trim().split(',');
			const sizechunks = chunks[1].trim().split(',');
			if (rowchunks.length !== sizechunks.length) {
				throw new Error("Expected row chunks to equal size chunks on line " + (i+1));
			}
			
			for(let t=0; t < rowchunks.length; t++) {
				const r = rowchunks[t].trim().split('-');
				const s = sizechunks[t].trim().split('-');
				if (r.length === 1) { // it's just one row
					rows.push({'RowNumber': r[0].trim(), 'RowLength': convert(parseFloat(s[0].trim())).from(this.state.units).to('cm')});
				} else { // it's a sequence
					if (s.length === 1) {
						for(let j = parseInt(r[0]); j <= parseInt(r[1]); j++) {
							rows.push({'RowNumber': "" + j, 'RowLength': convert(parseFloat(s[0].trim())).from(this.state.units).to('cm')});
						}
					} else { // It's a size sequence
						const start = parseFloat(s[0].trim());
						const end = parseFloat(s[1].trim());
						const inc = (end - start) / (parseFloat(r[1]) - parseFloat(r[0]));
						for(let j = parseInt(r[0]); j <= parseInt(r[1]); j++) {
							rows.push({'RowNumber': "" + j, 'RowLength': convert(start + inc*(j - parseInt(r[0]))).from(this.state.units).to('cm')});
						}
					}
				}
				
			}
		}
		return rows;
	}
	
	
	onRowsAdded(id) {
		if (this.props.onAdded)
			this.props.onAdded(id);
	}
	
	
	render() {
		console.log(this.state);
		return (
			<div>
				<Loadable ready={this.state.units !== false}>
					<form onSubmit={this.onSubmit}>
							<label>Start date</label>
							<select value={this.state.startDatePreset} name="startDatePreset" onChange={this.onDatePresetChange}>
								<option value="today">Today</option>
								<option value="field">Field start date ({this.props.field.StartDate})</option>
								<option value="custom">Other</option>
							</select>
							<ShowIff iff={this.state.startDatePreset === 'custom'}>
								<DatePicker
									id="startDate"
									selected={this.state.startDate}
									onChange={this.onStartDateChange}
								/>
							</ShowIff>
							<label>Units</label> <select name="units" value={this.state.units} onChange={this.onChange}>
								<option value="cm">cm</option>
								<option value="in">Inches</option>
								<option value="ft-us">Feet</option>
							</select>
							<label>Row data</label>
							<p>List data can be of the format: <strong>row:length</strong></p>
							<p>You can specify row as one row, a list of rows separated by commas, or a range with a dash.</p>
							<textarea value={this.state.text} name="text" onChange={this.onChange} />
							<p>Examples:</p>
							<ul>
								<li>1-10:50 <small>(rows 1 to 10, all of length 50)</small></li>
								<li>12:40 <small>(row 12, of length 40)</small></li>
								<li>15-20:60-70 <small>(rows 15 to 20, starting at length 60 with row 15, and increasing in increments to 70 at row 20)</small></li>
								<li>23,24:80,90 <small>(rows 23 and 24, of lengths 80 and 90, respectively)</small></li>
							</ul>
							<p>Or any combination therein.</p>
							<input type="submit" value="Add rows" />
					</form>
				</Loadable>
			</div>
		);
	}
}

export default AddRowForm;
